/* zeit-und-raum: Auswahl eines bestehenden Gesamtzyklus-Produkts. */
(() => {
  'use strict';

  const tagName = 'zr-training-registration';
  if (!window.customElements || customElements.get(tagName)) return;

  class TrainingRegistration extends HTMLElement {
    connectedCallback() {
      this.initFrame = requestAnimationFrame(() => this.initialize());
    }

    initialize() {
      if (this.controller || !this.isConnected) return;

      this.ui = this.querySelector('[data-registration-ui]');
      this.fallback = this.querySelector('[data-registration-fallback]');
      this.summary = this.querySelector('[data-registration-summary]');
      this.link = this.querySelector('[data-registration-continue]');
      this.paths = this.querySelector('[data-registration-paths]');
      this.pathInputs = Array.from(this.querySelectorAll('[data-registration-path]'));

      if (!this.ui || !this.fallback || !this.summary || !this.link) return;

      this.urls = {
        regular: this.safeUrl(this.dataset.urlRegular),
        repeat: this.safeUrl(this.dataset.urlRepeat),
        advanced: this.safeUrl(this.dataset.urlAdvanced),
        online: this.safeUrl(this.dataset.urlOnline)
      };
      if (!Object.values(this.urls).some(Boolean)) return;

      this.controller = new AbortController();
      const options = { signal: this.controller.signal };

      this.addEventListener('change', (event) => {
        if (!(event.target instanceof HTMLInputElement)) return;

        // Ein Formatwechsel entfernt die bisherige Praesenz-Auswahl.
        if (event.target.matches('[data-registration-format]')) {
          this.pathInputs.forEach((input) => { input.checked = false; });
        }
        this.refresh();
      }, options);

      this.link.addEventListener('click', (event) => {
        if (!this.currentUrl) event.preventDefault();
      }, options);

      window.addEventListener('pageshow', () => this.refresh(), options);
      this.refresh();
      this.ui.hidden = false;
      this.fallback.hidden = true;
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame);
      if (this.controller) this.controller.abort();
      this.controller = null;
    }

    safeUrl(value) {
      if (!value) return '';
      try {
        const url = new URL(value, window.location.origin);
        if (url.origin !== window.location.origin) return '';
        if (!['https:', 'http:'].includes(url.protocol)) return '';
        return url.pathname + url.search + url.hash;
      } catch {
        return '';
      }
    }

    refresh() {
      const selectedFormat = this.querySelector('[data-registration-format]:checked');
      const format = this.dataset.fixedFormat || (selectedFormat ? selectedFormat.value : '');
      const onsite = format === 'onsite';
      const place = this.dataset.onsiteLabel || 'Vor Ort';

      if (this.paths) {
        this.paths.hidden = !onsite;
        this.paths.disabled = !onsite;
      }

      if (!onsite) {
        this.pathInputs.forEach((input) => { input.checked = false; });
      } else if (this.pathInputs.length === 1) {
        // Bei genau einem Praesenzangebot ist keine zweite Entscheidung noetig.
        this.pathInputs[0].checked = true;
      }

      let url = '';
      let message = 'Bitte wähle zuerst, wie Du teilnehmen möchtest.';

      if (format === 'online') {
        url = this.urls.online;
        message = 'Deine Auswahl: Online · alle fünf Module II–VI.';
      } else if (onsite) {
        const selectedPath = this.pathInputs.find((input) => input.checked);
        message = 'Bitte wähle Deine Teilnahme für ' + place + '.';
        if (selectedPath) {
          url = this.urls[selectedPath.value] || '';
          message = 'Deine Auswahl: ' + place + ' · ' + selectedPath.dataset.label
            + ' · alle fünf Module II–VI.';
        }
      }

      this.currentUrl = url;
      this.summary.textContent = message;
      this.link.setAttribute('aria-disabled', url ? 'false' : 'true');

      if (url) {
        this.link.setAttribute('href', url);
        this.link.removeAttribute('tabindex');
      } else {
        this.link.removeAttribute('href');
        this.link.setAttribute('tabindex', '-1');
      }

      this.querySelectorAll('.event-training-registration__choice').forEach((label) => {
        const input = label.querySelector('input');
        label.classList.toggle('is-selected', Boolean(input && input.checked));
      });
    }
  }

  customElements.define(tagName, TrainingRegistration);
})();